import BaseModelAPI from '../BaseModelAPI';

export default class LineList extends BaseModelAPI {

	static entity = 'linelist'
	static entityName = 'line';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
